import {
  CostingHistoryEntry,
  PredefinedFormats,
  PredefinedOp,
  PredefinedQt,
  PredefinedRt,
  SaveCostingPayload,
} from "../interfaces/app_types";
import Axios from "../utils/Axios";

export const getCostingParameters = async (): Promise<PredefinedOp[]> => {
  const { data } = await Axios.get<PredefinedOp[]>("/costing/parameters");
  return data;
};

export const getCostingQuantity = async (): Promise<PredefinedQt[]> => {
  const { data } = await Axios.get<PredefinedQt[]>("/costing/quantities");
  return data;
};

export const getCostingRmRates = async (): Promise<PredefinedRt[]> => {
  const { data } = await Axios.get<PredefinedRt[]>("/costing/rmrates");
  return data;
};

export const getCostingFormats = async (): Promise<PredefinedFormats[]> => {
  const { data } = await Axios.get<PredefinedFormats[]>("/costing/formats");
  return data;
};

export const saveCostingRun = async (
  payload: SaveCostingPayload
): Promise<void> => {
  const response = await Axios.post("/costing/save-costing", payload, {
    responseType: "blob",
  });

  const blob = new Blob([response.data as BlobPart], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${payload.title}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const getCostingHistory = async (): Promise<CostingHistoryEntry[]> => {
  const { data } = await Axios.get<CostingHistoryEntry[]>("/costing/history");
  return data;
};
